import { useBulkMessageProposal } from "@/hooks/useBulkMessageProposal";
import { useOrg } from "@/hooks/useOrg";
import React from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormValues, BulkMessageSendFilterType } from "../types";
import { Spinner } from "@/assets/svg/Spinner";
import { StudentBar } from "../StudentBar";
import { FilterTypeSelection } from "./FilterTypeSelection";
import { FiltersForm } from "./FiltersForm";
import { useFilters } from "../hooks/useFilters";
import { formToFilterApi } from "../utils/mutationBuilders";
import { useOutletContext } from "react-router-dom";
import { BulkMessageOutletContext } from "../SendBulkMessage";

interface StudentFiltersProps {
  filterType: BulkMessageSendFilterType;
  setFilterType: React.Dispatch<
    React.SetStateAction<BulkMessageSendFilterType>
  >;
}

export function StudentFilters({
  filterType,
  setFilterType,
}: StudentFiltersProps) {
  const { isActive } = useOutletContext<BulkMessageOutletContext>();
  const form = useFormContext<FormValues>();
  const { org } = useOrg();
  const { watch } = form;

  const { students, loading: proposalLoading } = useBulkMessageProposal({
    orgId: org?.id,
    filters: formToFilterApi(watch("filters")),
  });

  const { filters, loading: filtersLoading } = useFilters();

  const { t } = useTranslation("translation", {
    keyPrefix: "bulkMessaging.basicInformation.studentFilters",
  });

  return (
    <div className="flex flex-col">
      <div className="border-b p-6">
        {filtersLoading || proposalLoading ? (
          <div className="flex h-20 flex-col items-center justify-center gap-2">
            <Spinner className="size-4 fill-white text-black/50" />
            <p>{t("loadingStudents")}</p>
          </div>
        ) : (
          <StudentBar students={students} />
        )}
      </div>
      <FilterTypeSelection
        filterType={filterType}
        setFilterType={setFilterType}
        disabled={isActive}
      />
      <div className="p-6">
        {filtersLoading || !filters ? (
          <div className="flex h-20 flex-col items-center">
            <Spinner className="size-4 fill-white text-black/50" />
          </div>
        ) : (
          <FiltersForm filters={filters} disabled={isActive} />
        )}
      </div>
    </div>
  );
}
